module.exports = __webpack_public_path__ + "img/IMG_2637.dc7d9674.jpg";